<template>
    <div class="col-lg-6 col-sm-12 order-0">
        <div id="shop-heading-container" class="p-3 pt-5 row">
            <div class="col-auto image-container">
                <avatar-badge no-margin :src="displayImage" update-event="display-image-updated" :raised="false" :size="160"></avatar-badge>
            </div>
            <div id="profile-heading" class="col">
                <router-link :to="shopLink" target="_blank">
                    <h2 class="display-4 montserrat-bold mb-0 link-hover-line" style="margin-top: 2rem !important;" v-text="shop.name"></h2>
                </router-link>
                <div class="mt--2 heading-small" v-text="displayedAddress"></div>
                <div v-if="shop.mobile_no" class="mt--2 heading-small" v-text="mobileNo"></div>
                <div v-else class="mt--2 heading-small text-muted">No mobile number</div>
                <div v-if="shop.landline_no" class="mt--2 heading-small" v-text="landlineNo"></div>
                <div v-else class="mt--2 heading-small text-muted">No landline number</div>
            </div>
        </div>
    </div>
</template>
<script>
import { pageRoute } from "@utils/network";

export default {
    name: "ShopProfileSection",
    computed: {
        shop() {
            return this.$store.getters.shop;
        },
        displayedAddress() {
            return this.shop.address ? this.shop.address.display_name : "";
        },
        displayImage() {
            return this.shop.display_image || "/images/placeholders/avatar.jpg";
        },
        mobileNo() {
            return this.shop.mobile_no;
        },
        landlineNo() {
            return this.shop.landline_no;
        },
        shopLink() {
            return pageRoute('/shops/:id/about', { id: this.shop.id }, false);
        },
    }
}
</script>
<style lang="css" scoped>
    #profile-heading-container {
        border-radius: 6px;
        background-color: white;
    }
    #profile-heading-container .image-container {
        padding: 0px 15px 0px;
    }
    #profile-heading {
        padding: 0px 19px 0px;
    }
</style>